<template>
  <div>
    <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      House
    </button>
    <a-modal v-model="visible" title="Add a new House">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="loading"
          @click="handleSubmit"
          >Add House</a-button
        >
      </template>

      <a-form class="mb-4" :form="form">
        <a-form-item label="Name">
          <a-input
            placeholder="Name"
            v-decorator="[
              'name',
              {
                rules: [
                  { required: true, message: 'Please input house name!' },
                  { max: 20, message: 'Must not exceed 20 characters!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Code">
          <a-input
            placeholder="Code"
            v-decorator="[
              'code',
              {
                rules: [
                  { required: true, message: 'Please input code name!' },
                  { max: 20, message: 'Must not exceed 20 characters!' },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="Description">
          <a-textarea
            placeholder="Description"
            :autosize="{ minRows: 2 }"
            v-decorator="[
              'description',
              {
                rules: [
                  { max: 100, message: 'Must not exceed 100 characters!' },
                ],
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'AddHouse',
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
    }
  },
  methods: {
    showModal() {
      this.visible = true
    },

    handleSubmit(e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to add ${values.name}?`,
            content: `Click on the OK button to add the new house!`,
            onOk: () => {
              this.$http
                .post('/api/house', {
                  name: values.name,
                  description: values.description,
                  code: values.code,
                })
                .then(({ data }) => {
                  this.$emit('created')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'House successfully added',
                    description: `${data.data.name} added successfully!`,
                  })
                  this.form.resetFields()
                })
                .catch((error) => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }

        this.loading = false
      })
    },
    handleCancel(e) {
      this.visible = false
    },
  },
}
</script>
